"use client";
// @ts-strict-ignore
import * as React from "react";
import { SocialsIcon } from "./style";
import FacebookIcon from "./images/facebook.svg";
import TwitterIcon from "./images/twitter.svg";
import LinkedInIcon from "./images/linkedin.svg";
import LinkIcon from "./images/copy.svg";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton
} from "react-share";
import { Body } from "components/parts/Typography";
import copy from "copy-to-clipboard";
import { useEffect, useState } from "react";

export const SocialIcons = (titleObject) => {
  const [showCopiedText, setShowCopiedText] = useState<boolean>(false);
  const [windowLocation, setWindowLocation] = useState("");
  const quote = `${titleObject.title} @Gemini`;
  const handleCopyLink = () => {
    setShowCopiedText(true);
    copy(`${windowLocation}`);
  };

  useEffect(() => {
    setWindowLocation(`${window?.location.href}`);
  }, [windowLocation]);

  return (
    <div css={{ display: "flex" }}>
      <TwitterShareButton url={windowLocation} title={quote}>
        <SocialsIcon src={TwitterIcon} alt="Twitter" />
      </TwitterShareButton>
      <FacebookShareButton url={windowLocation} hashtag={quote}>
        <SocialsIcon src={FacebookIcon} alt="Facebook" />
      </FacebookShareButton>
      <LinkedinShareButton url={windowLocation} title={quote}>
        <SocialsIcon src={LinkedInIcon} alt="LinkedIn" />
      </LinkedinShareButton>
      <div>
        <SocialsIcon
          src={LinkIcon}
          alt="link"
          onClick={handleCopyLink}
          css={`
            cursor: pointer;
            &:hover {
              filter: invert();
            }
          `}
        />
        <br />
        {!!showCopiedText && (
          <Body
            size="xs"
            css={`
              position: absolute;
              font-size: 9px;
              line-height: 12px;
              transition: ease-out 3s;
            `}
          >
            Link copied
          </Body>
        )}
      </div>
    </div>
  );
};

export default SocialIcons;
